// Self-xss warning mostly based on https://github.com/sammwyy/no-self-xss/blob/main/lib/no-self-xss.js
const TRANSLATIONS: any = {
  ar: {
    title: 'قف!',
    subtitle: 'إذا أخبرك شخص ما بنسخ شيء ما ولصقه هنا ، فهناك فرصة بنسبة 101٪ لتضليلك.',
    warn: 'يمكن أن يؤدي لصق شيء ما هنا إلى منح المهاجمين حق الوصول إلى حسابك.',
    info: 'ما لم تكن تفهم بالضبط ما تفعله ، أغلق هذه النافذة وكن آمنًا. \n\n لمزيد من المعلومات ، تفضل بزيارة https://ar.wikipedia.org/wiki/الهجمة_الذاتية-إكس-أس-أس'
  },

  bn: {
    title: 'থামো!',
    subtitle:
      'যদি কেউ আপনাকে এখানে কিছু অনুলিপি করে আটকে দিতে বলে থাকে তবে 101% সুযোগ রয়েছে যে আপনাকে বিভ্রান্ত করা হয়েছে।',
    warn: 'এখানে কিছু আটকানো আক্রমণকারীদের আপনার অ্যাকাউন্টে অ্যাক্সেস দিতে পারে।',
    info: 'আপনি কী করছেন ঠিক বুঝতে না পারলে এই উইন্ডোটি বন্ধ করুন এবং সুরক্ষিত থাকুন।\n\nআরও তথ্যের জন্য, https://en.wikedia.org/wiki/Self-XSS দেখুন'
  },

  cn: {
    title: '停止！',
    subtitle: '如果有人告诉您在此处复制并粘贴某些内容，那么您被误导的可能性为101％。',
    warn: '在此处粘贴内容可以使攻击者访问您的帐户。',
    info: '除非您确切了解自己在做什么，否则请关闭此窗口并确保安全。\n\n有关更多信息，请访问 https://en.wikipedia.org/wiki/Self-XSS'
  },

  de: {
    title: 'Halt!',
    subtitle:
      'Wenn Ihnen jemand gesagt hat, dass Sie hier etwas kopieren und einfügen sollen, besteht eine 101% ige Wahrscheinlichkeit, dass Sie irregeführt wurden.',
    warn: 'Wenn Sie hier etwas einfügen, können Angreifer auf Ihr Konto zugreifen.',
    info: 'Wenn Sie nicht genau verstehen, was Sie tun, schließen Sie dieses Fenster und bleiben Sie sicher. \n\nWeitere Informationen finden Sie unter https://en.wikipedia.org/wiki/Self-XSS'
  },

  en: {
    title: 'Stop!',
    subtitle:
      'If someone has told you to copy and paste something here, there is a 101% chance that you have been misled.',
    warn: 'Pasting something here can give attackers access to your account.',
    info: 'Unless you understand exactly what you are doing, close this window and stay safe.\n\nFor more information, visit https://en.wikipedia.org/wiki/Self-XSS'
  },

  es: {
    title: '¡Detente!',
    subtitle:
      'Si alguien te ha dicho que copies y pegues algo aquí, hay una probabilidad del 101% de que te hayan engañado.',
    warn: 'Pegar algo aquí puede dar acceso a atacantes a tu cuenta.',
    info: 'A menos que entiendas exactamente lo que estás haciendo, cierra esta ventana y mantente a salvo.\n\nPara mas información, visita https://es.wikipedia.org/wiki/Self-XSS'
  },

  fil: {
    title: 'Tigilan mo na!',
    subtitle:
      'Kung may nagsabi sa iyo na kopyahin at i-paste ang isang bagay dito, mayroong isang 101% na pagkakataon na na-misle ka.',
    warn: 'Ang paglagay ng isang bagay dito ay maaaring magbigay sa mga umaatake ng access sa iyong account.',
    info: 'Maliban kung naiintindihan mo nang eksakto kung ano ang iyong ginagawa, isara ang window na ito at manatiling ligtas. \n\n Para sa karagdagang impormasyon, bisitahin ang https://en.wikipedia.org/wiki/Self-XSS'
  },

  fr: {
    title: 'Arrêtez!',
    subtitle:
      "Si quelqu'un vous a dit de copier et coller quelque chose ici, il y a 101% de chances que vous ayez été induit en erreur.",
    warn: "Coller quelque chose ici peut permettre aux attaquants d'accéder à votre compte.",
    info: "À moins que vous ne compreniez exactement ce que vous faites, fermez cette fenêtre et restez en sécurité. \n\nPour plus d'informations, visitez https://en.wikipedia.org/wiki/Self-XSS"
  },

  hu: {
    title: 'Állj!',
    subtitle: 'Ha valaki azt kérte tőled hogy másolj be ide egy szöveget, akkor nagy valószínűséggel át akar ejteni.',
    warn: 'Bármit ami idemásolsz az mások számára elérhetővé teheti a felhasználói fiókodat.',
    info: 'Hacsak nem tudod, hogy mit csinálsz, kérlek zárd be ezt az ablakot, hogy a felhasználói fiókod biztonságban maradjon.\n\nTovábbi információkért kérlek nézd meg a https://en.wikipedia.org/wiki/Self-XSS oldalt'
  },

  id: {
    title: 'Berhenti!',
    subtitle:
      'Jika seseorang menyuruh Anda menyalin dan menempelkan sesuatu di sini, ada kemungkinan 101% Anda telah disesatkan.',
    warn: 'Menempelkan sesuatu di sini dapat memberi penyerang akses ke akun Anda.',
    info: 'Kecuali Anda benar-benar memahami apa yang Anda lakukan, tutup jendela ini dan tetap aman.\n\nUntuk informasi lebih lanjut, kunjungi https://en.wikipedia.org/wiki/Self-XSS'
  },

  it: {
    title: 'Stop!',
    subtitle:
      "Se qualcuno ti ha detto di copiare e incollare qualcosa qui, c'è una probabilità del 101% che tu sia stato ingannato.",
    warn: 'Incollare qualcosa qui può consentire agli aggressori di accedere al tuo account.',
    info: 'A meno che tu non capisca esattamente cosa stai facendo, chiudi questa finestra e rimani al sicuro.\n\nPer ulteriori informazioni, visita https://it.wikipedia.org/wiki/Self-XSS'
  },

  hi: {
    title: 'रुकें!',
    subtitle:
      'यदि किसी ने आपको यहां कुछ कॉपी और पेस्ट करने के लिए कहा है, तो 101% संभावना है कि आपको गुमराह किया गया है।',
    warn: 'यहां कुछ चखने से हमलावरों को आपके खाते तक पहुंच मिल सकती है।',
    info: 'जब तक आप वास्तव में समझ नहीं पाते कि आप क्या कर रहे हैं, इस विंडो को बंद करें और सुरक्षित रहें।\n\nअधिक जानकारी के लिए, https://en.wikipedia.org/wiki/Self-XSS पर जाएं'
  },

  ja: {
    title: 'やめる！',
    subtitle: '誰かがここに何かをコピーして貼り付けるように言った場合、あなたが誤解されている可能性は101％です。',
    warn: 'ここに何かを貼り付けると、攻撃者があなたのアカウントにアクセスできるようになる可能性があります。',
    info: '自分がしていることを正確に理解していない限り、このウィンドウを閉じて安全を確保してください\n\n詳細については、https://en.wikipedia.org/wiki/Self-XSS にアクセスしてください。'
  },

  ko: {
    title: '중지!',
    subtitle: '누군가 여기에 무언가를 복사하여 붙여 넣으라고했다면 오해를 당했을 가능성이 101 %입니다.',
    warn: '여기에 무언가를 붙여 넣으면 공격자가 귀하의 계정에 액세스 할 수 있습니다.',
    info: '수행중인 작업을 정확히 이해하지 못한 경우이 창을 닫고 안전을 유지하십시오.\n\n자세한 내용은 https://en.wikipedia.org/wiki/Self-XSS 를참조하십시오.'
  },

  nl: {
    title: 'Hou op!',
    subtitle:
      'Als iemand je heeft gezegd hier iets te kopiëren en te plakken, is er een kans van 101% dat je bent misleid.',
    warn: 'Als u hier iets plakt, kunnen aanvallers toegang krijgen tot uw account.',
    info: 'Sluit dit venster en blijf veilig, tenzij u precies begrijpt wat u doet.\n\nGa voor meer informatie naar https://en.wikipedia.org/wiki/Self-XSS'
  },

  pt: {
    title: 'Pare!',
    subtitle: 'Se alguém lhe disse para copiar e colar algo aqui, há 101% de chance de você ter sido enganado.',
    warn: 'Colar algo aqui pode dar aos invasores acesso à sua conta.',
    info: 'A menos que você entenda exatamente o que está fazendo, feche esta janela e fique seguro. \n\nPara obter mais informações, visite https://en.wikipedia.org/wiki/Self-XSS'
  },

  ru: {
    title: 'Стоп!',
    subtitle:
      'Если кто-то сказал вам скопировать и вставить что-то сюда, существует 101% шанс, что вас ввели в заблуждение.',
    warn: 'Вставив что-то сюда, злоумышленники могут получить доступ к вашей учетной записи.',
    info: 'Если вы точно не понимаете, что делаете, закройте это окно и оставайтесь в безопасности.\n\nДля получения дополнительной информации посетите https://en.wikipedia.org/wiki/Self-XSS'
  },

  tr: {
    title: 'Dur!',
    subtitle: 'Biri size buraya bir şeyi kopyalayıp yapıştırmanızı söylediyse,% 101 olasılıkla yanıltılmışsınızdır.',
    warn: 'Buraya bir şey yapıştırmak saldırganların hesabınıza erişmesini sağlayabilir.',
    info: 'Tam olarak ne yaptığınızı anlamadıkça, bu pencereyi kapatın ve güvende kalın.\n\nDaha fazla bilgi için https://en.wikipedia.org/wiki/Self-XSS adresini ziyaret edin.'
  }
}

export default function () {
  let c = function (r: number, g: number, b: number) {
    return `color: rgb(${r},${g},${b}); font-family: monospace;`
  }

  console.log(
    '%c\n%c                                                                            %c░%c %c                     %c░%c\n%c                                                                           %c░░░%c                     %c░░%c\n%c                                                                          %c░%c░%c░░%c                    %c░%c░%c░%c░%c\n%c                                                                         %c░%c▒%c░░░%c                    %c░░%c░%c▒%c %c\n%c                                                                         %c░%c▒%c░░░%c                    %c░░%c░%c░%c░%c\n%c                                                                        %c░%c░%c░%c░░░%c                   %c░░░%c░%c░░%c\n%c                                                                        %c░%c░%c░░░%c░%c                  %c░%c░%c░░%c░%c░░%c\n%c                                                                        %c░%c░%c░%c░░░%c                 %c░%c░%c░%c░░%c░%c░%c %c\n%c                                                                        %c░%c░░░░░%c %c    %c░%c          %c░%c░░░░%c░%c░%c░%c\n%c                                                                        %c░%c░%c▒%c░░%c░░%c  %c %c %c      %c %c %c  %c░%c░%c░░░░░░%c\n%c                                                                         %c %c     %c %c %c %c   %c░%c▒▒▒%c %c %c %c %c░░%c░%c░%c░%c░%c░%c             %c %c▒▒▒▒▒▒%c\n%c                                                                        %c %c       %c %c░%c▒▒▒▒▒▒▒%c %c %c %c      %c %c            %c %c▒▒▒%c▓▓%c▒▒▒▒%c\n%c                                                                         %c %c     %c░%c▒%c▒%c▒%c▒▒▒▒%c▒%c▒%c▒%c %c      %c %c %c           %c %c▒▒▒▒▒▒▒▒▒▒▒%c\n%c                                                                            %c %c %c %c▓%c▓▓▓▓▓▓▓▓▓▓%c▓%c▒%c %c░░%c %c▒%c▒%c▒%c▒%c          %c▒%c▒▒%c▒▒▒▒▒▒▒▒▒%c  %c %c▒▒▒▒%c░%c\n%c                                                                           %c▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓%c▒%c %c %c %c▓▓▓%c▒%c▒%c        %c %c▒%c▒%c▒%c▒%c▒%c▒%c▒%c▒▒▒%c▒▒▒▒▒▒▒▒▒▒▒▒%c %c\n%c                                                                          %c▓%c %c %c %c▓▓▓▓▓▓▓▓▓▓▓▓%c %c %c░%c░%c░%c░░%c %c▓%c▓%c▒%c▒%c      %c▒%c░%c▒▒▒▒▒▒▒▒▒%c▒%c▒%c▒%c▒%c▒%c▒%c▒%c▒%c▒%c▒▒▒▒▒%c\n%c                                                                         %c▓%c▒%c %c %c %c %c▓▓▓▓▓▓▓▓▓▓%c▓%c▒▒%c▓%c▓▓▓▓%c %c %c▓%c▒%c▒%c     %c▒%c██████%c %c▒▒▒▒▒▒▒▒▒▒▒▒▒%c▒%c▒%c▒%c▒%c▒%c\n%c                                                                         %c▓▓▓▓%c▓%c▒%c▒%c▒%c▓▓▓▓▓▓▓%c▓%c▒%c░%c %c▒▒▒%c %c▓▓%c %c▓%c▒%c▒%c    %c▒%c▓%c█████%c▓%c▓%c %c▒%c▒▒▒▒▒▒▒▒▒▒▒▒▒%c▒%c▒%c\n%c                                                                        %c %c▓%c %c▒%c %c  %c▒%c▒%c▓%c▓▓▓▓▓▓▓%c▓%c▒%c %c░░%c░%c░%c▒%c▒%c▓▓%c▒%c▒%c    %c %c▓%c▓%c▓▓%c▓%c▓%c▓%c▒%c▒%c▒%c▒%c▒%c▒%c▒▒▒▒▒▒%c▒%c▒%c▒▒%c %c\n%c                                                                        %c %c▒%c▓%c▒%c░%c░%c█%c %c▒%c▓▓▓▓▓▓▓▓%c░%c█%c░░%c██%c░░%c░%c▓▓%c▒%c▒%c     %c %c▒%c▒%c %c░%c░░░░░%c▒%c▒%c▒▒%c▒%c▒%c▒%c▒▒%c░%c░%c\n%c                                                               %c▒▒%c▒%c▒▒%c░%c░%c %c░%c %c▓%c█%c %c░%c░%c█%c░%c %c▓▓▓▓▓▓▓▓%c▓%c█%c░%c░%c▓%c█%c░%c %c %c▓▓%c▒%c %c▒%c▒%c░%c  %c▒▒▒%c▒%c░░░░░░░░░░░░%c %c\n%c                                                             %c▒%c▒%c▒%c░%c░%c░%c▒%c░░░%c▒▒%c▓%c▓%c█%c░%c░%c▒%c░%c %c░%c▒%c %c %c▓▓▓▓%c▓%c██%c %c░%c %c█%c %c▓▓%c▒%c▒▒%c▒%c    %c %c %c▒▒%c %c %c %c░%c▒%c▒▒%c\n%c                                                            %c %c▒%c░%c░%c░░░░%c░░░%c░%c▒%c░%c▓▓%c %c░%c %c▓%c▓▓▓%c▓%c▓▓▓▓▓▓▓▓%c▒%c▓%c▓▓▓▓%c▓%c▒%c░%c %c   %c░%c░%c %c  %c░%c▒%c▒%c\n%c                                                            %c░%c░%c░%c░░%c░%c░%c░░░░░░%c▒%c▒%c▓▓▓▓▓%c▓%c▓%c▓▓▓▓▓▓▓▓▓▓%c▓%c▓▓▓▓%c▒%c▒%c %c░%c  %c░%c░%c░%c░%c\n%c                                                             %c░%c░%c░%c░%c░%c░░░%c░%c█%c▒%c▒%c %c░%c▒%c▓▓▓%c▓%c▓▓▓▓▓▓▓▓%c %c▓%c▓▓▓▓▓%c▓%c▒%c %c▒%c▒%c▒%c░%c %c %c░%c\n%c                                                              %c %c░░░░░░%c▓%c▓%c▒▒▒%c  %c %c %c▓▓▓▓▓%c█%c▓%c█%c▓%c▓▓▓▓▓▓▓%c %c▒%c░%c▒%c▒%c▒%c▒%c▓%c▒%c                      %c▒%c   %c▓▓▓▓▓▓▓▓▓%c▓%c▓%c\n%c                                                               %c %c░░%c %c░%c░%c░%c %c      %c░%c░%c▒▒%c %c▓▓▓▓▓▓▓▓%c %c▒▒▒▒▒▒%c %c▒%c▒%c▒%c▒%c %c░░%c░%c                %c▓▓▓▓▓▓▓▓▓▓%c▓%c▓▓▓▓%c▓%c▓%c\n%c                                                                             %c %c▒▒%c▒%c▒▒▒%c▒%c▒%c▒%c▒%c▒%c▒▒▒%c▒%c▒▒▒▒▒▒%c %c▒%c %c░%c░%c░░%c░%c            %c▓%c▓%c▓▓▓▓▓▓%c▓%c▓▓%c▓%c▓▓▓%c▓%c▓%c▓%c▓%c\n%c                                                                              %c▒%c▒%c▒%c▒%c▒▒▒▒▒▒▒▒%c▒%c▒%c▒%c %c▓%c▓%c▒%c▒▒▒▒%c %c░░░%c░░░%c         %c▓%c▓▓%c▓%c▓%c▓▓%c %c▓▓▓▓▓%c▓%c▓%c▓%c▓▓%c▓%c░%c\n%c                                                            %c░%c▒%c▒%c %c %c░%c▒%c %c▒▒▒▒%c %c %c   %c %c▓%c▓▓%c▓%c▓▓%c▓%c▓%c▓%c▓▓▓▓%c▓%c▓▓▓▓%c▓%c▒%c▒%c░%c▒▒%c▒%c▒%c %c░%c░%c░%c░%c       %c▓%c▓%c▓▓▓%c▓%c▓%c▓%c▓▓▓%c▓%c▓%c▓%c▓▓%c▓%c▓%c▒%c\n%c                                                       %c░%c▓%c▓%c▓▓%c▓%c▓%c▒%c▒%c▒▒%c░%c▒▒%c▒%c▒▒▒%c %c░%c  %c░%c▒%c▓▓%c▓%c▓▓%c▓%c▓%c▓%c▓%c▓▓%c▓%c▓▓▓▓%c▓%c▒%c░%c▒%c▒%c▒%c▓%c▓%c▒%c░░%c░%c░%c▒%c     %c▒%c▒%c▓%c▓%c▓%c▒%c▓%c▓%c▓▓▓▓▓▓%c▓%c▓▓%c▒%c %c\n%c                                                      %c %c▓%c▓%c▓%c▓%c▓▓%c▓%c▓▓%c▒%c▒▒▒%c %c█%c▓%c▒▒%c▒▒%c    %c▒%c▓▓%c %c▓%c▓%c▓%c▓%c▓%c▒%c▓▓▓▓▓▓▓%c▓%c▒▒%c %c▒▒▒▒%c %c %c %c░%c░%c %c█%c▒%c░%c▒%c▒▒▒▒%c░%c▓%c▓▓▓▓%c▓%c▓%c▓%c▓%c▒%c\n%c                                                         %c▓%c▓▓%c▓%c▓▓%c▓%c▒▒%c░%c▒%c░%c█%c▓%c▒%c▒%c▒%c    %c░%c %c▓%c▓%c▓▓%c▓%c▓%c█%c▓%c▓▓▓%c▓%c▓▓▓%c▓%c▒%c▒▒%c %c░░░░░░░%c░%c %c▒▒%c %c▓%c█%c▓%c %c░%c▒▒▒▒%c▒%c▒%c▒%c▒%c\n%c                                                                  %c▒▒▒▒%c %c▒%c      %c░░%c %c▓%c▓%c▓%c▓%c▓%c▓%c▓▓▓%c▓%c▓▓▓%c▒%c░%c▒▒%c░%c░░░░░░░░░%c▒▒▒▒%c▓%c████%c░%c▒%c▒%c %c\n%c            %c███%c                  %c███████████%c    %c██████████%c       %c▒%c▓%c▒%c▒%c░%c██████████████%c▓%c▓%c▓%c▓%c▓%c▓%c▓%c▓%c▓▓▓%c  %c▒%c█████████%c▒%c░%c %c▒▒▒%c▒%c▒%c▒▒%c▒%c▒▒%c████████%c      %c█████%c\n%c      %c████████████%c             %c█████████████████████████████%c     %c▒%c▓%c %c███████████████████████████████████████████%c▒%c▒%c▒%c▒▒▒▒%c %c███████████%c %c████████████████%c\n%c  %c██████████████████%c          %c████████████████████████████████%c      %c██████████████████████████████████████████%c▓%c▓%c▓%c███████████████████████████████████%c\n%c %c███████████%c▒▒%c██████████████████████%c▒▒▒▒▒▒▒%c▒%c████%c▓%c▒▒▒▒▒▒▒%c███████%c    %c██████%c▒▒▒▒▒▒▒▒▒▒▒%c▒%c▓%c███████████%c▓%c▒▒▒▒▒▒▒▒▒%c▓%c██%c▓%c█████%c▒▒▒▒▒▒▒▒▒%c▒%c█████████%c▓%c▒%c▒%c▓%c▓%c█████████%c\n%c██████%c▓%c▒▒▒▒▒▒▒▒%c████████████████████%c▓%c▒▒▒▒▒▒▒▒%c███%c▒▒▒▒▒▒▒▒▒▒%c███████%c   %c██████%c▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒%c▓%c▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒%c %c▒%c█████%c▒▒▒▒▒▒▒▒▒▒▒%c████████%c▒▒▒▒▒▒▒▒%c██████%c\n%c██████%c▒▒▒▒▒▒▒▒▒▒%c███████████████████%c▒▒▒▒▒▒▒▒▒%c██%c▒▒▒▒▒▒▒▒▒▒▒▒%c▓%c██████%c  %c██████%c▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒%c█%c▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒%c▓%c███%c▒▒▒▒▒▒▒▒▒▒▒▒%c███████%c▒▒▒▒▒▒▒▒%c██████%c░\n%c %c██████%c▒▒▒▒▒▒▒▒▒%c▒%c█████%c▒▒▒▒▒▒▒▒%c█████%c▒▒▒▒▒▒▒▒%c██%c▒▒▒▒▒▒▒▒▒▒▒▒▒▒%c▓%c████████████%c▒%c▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒%c█%c▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒%c▓%c██%c▒▒▒▒▒▒▒▒▒▒▒▒▒%c██████%c▒▒▒▒▒▒▒▒%c██████%c░\n%c %c░%c██████%c▒▒▒▒▒▒▒▒▒%c▓%c████%c▒▒▒▒▒▒▒▒%c████%c▒▒▒▒▒▒▒▒▒%c█%c▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒%c███████████%c▒▒▒▒▒▒▒▒%c▓%c██%c▓%c▒%c▒▒▒▒%c▓%c█%c▒▒▒▒▒▒▒▒%c▓%c█████%c▒▒▒▒▒▒▒▒▒%c██%c▒▒▒▒▒▒▒▒▒▒▒▒▒▒%c████%c▓%c▒▒▒▒▒▒▒%c▒%c█████%c░%c░\n%c %c░%c▒%c██████%c▒▒▒▒▒▒▒▒▒%c████%c▒▒▒▒▒▒▒▒▒%c███%c▒▒▒▒▒▒▒▒%c▒%c▓%c▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒%c██████████%c▒▒▒▒▒▒▒▒%c███████████%c▒▒▒▒▒▒▒▒%c▓%c█████%c▓%c▒▒▒▒▒▒▒▒%c██%c▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒%c███%c▒▒▒▒▒▒▒▒%c██████%c░%c░\n%c  %c░%c▓%c██████%c▒▒▒▒▒▒▒▒▒%c███%c▒▒▒▒▒▒▒▒▒%c██%c▒▒▒▒▒▒▒▒▒%c█%c▒▒▒▒▒▒▒▒%c▓%c█%c▒%c▒▒▒▒▒▒▒▒▒%c████████%c▓%c▒▒▒▒▒▒▒▒▒▒▒▒▒▒%c▒%c████%c▒▒▒▒▒▒▒▒%c▒%c█████%c▒▒▒▒▒▒▒▒▒%c██%c▒▒▒▒▒▒▒▒%c█%c▒▒▒▒▒▒▒%c██%c▒▒▒▒▒▒▒▒%c██████%c░%c\n%c   %c░%c██████%c▓%c▒▒▒▒▒▒▒▒▒%c█%c▓%c▒▒%c░%c░░░░░░░%c█%c░░░░░░░░░░░░░░░%c░░%c░%c███%c▒%c░%c▒%c▒▒▒▒▒▒▒%c███████%c▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒%c█████%c▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒%c▓%c██%c▒▒▒▒▒▒▒▒%c██%c▒▒▒▒▒▒▒%c█%c▒%c░%c░░░░░░%c██████%c░%c\n%c    %c░%c██████%c▒%c▒▒▒▒%c▒%c░░░░░░░░░░░░░░░░░░░░░░░░%c█%c░░░░░░░░%c█████%c▓%c░░░░░░░░░%c▓%c█████%c░░░░░░░%c░%c▒%c▒▒▒▒▒▒%c█████%c▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒%c▓%c███%c▒▒▒▒▒▒%c░%c░%c███%c░░░░░░░░░░░░░░%c▒%c█████%c░%c░%c\n%c     %c░%c██████%c░░░░░░░░░░░░░░░░░░░░░░░░░░░░%c▒%c░░░░░░░░░░░░░░%c█%c▓%c░░░░░░░░░%c░%c███%c▓%c░░░░░░░░%c██%c▓%c░░░%c██████%c░░░░░░░░░░░░░░░░░░░░░░%c░%c██%c░░░░░░░░%c████%c░░░░░░░░░░░░░%c██████%c░%c░%c\n%c      %c░%c██████%c░░░░░░░░░░░░░%c▓%c░░░░░░░░░░░░░%c▓%c░░░░░░░░░░░░░░%c███%c░░░░░░░░░░%c██%c░░░░░░░░%c░%c████████████%c▒%c░░░░░░░░%c█%c▓%c▓%c▓%c░░░░░░░░░░░%c█%c░░░░░░░░%c████%c▓%c░░░░░░░░░░░░%c██████%c░%c\n%c      %c░%c░%c██████%c░░░░░░░░░░░░%c██%c░░░░░░░░░░░%c█%c░░░░░░░░░░░░░░░%c████%c░░░░░░░░░░%c█%c░░░░░░░░%c█████████████%c▓%c░░░░░░░░%c█████%c▓%c░░░░░░░░░%c░%c░░░░░░░░%c█████%c▓%c░░░░░░░░░░░%c█████%c▓%c░%c\n%c       %c░%c░%c██████%c░░░░░░░░░░%c███%c░░░░░░░░░░%c██%c░░░░░░░░░░░░░░░%c█████%c░░░░░░░░░%c▒%c░░░░░░░░%c█████████████%c▓%c░░░░░░░░%c███████%c░░░░░░░░░░░░░░░░░%c██████%c░%c░░░░░░░░░%c▓%c█████%c░%c░%c\n%c        %c░%c▓%c██████%c░░░░░░░░%c▓%c████%c░░░░░░░░%c██%c░%c░░░░░░░%c▓%c█████████████%c░░░░%c▓%c███%c▓%c░░░░░░░░%c█████%c▓%c░░%c██████%c░░░░░░░░%c████████%c▓%c░░░░░%c▓%c█%c░░░░░░░░%c███████%c░%c░░░░░░░░%c██████%c░%c %c\n%c         %c░%c███████%c░░░%c░%c▒%c▓%c███████████████████%c▓%c░░░░%c████████████████████████████████████%c░░░%c██████%c░░░░░░░░%c██████████%c▓%c███████████████████████%c▒%c░░░░░%c██████%c░%c\n%c          %c░%c████████████████████████████████████████████%c▓%c░%c█████████████████████████%c░%c░%c %c %c███████████████████████████████████████████████████████████%c░░%c\n%c           %c░%c░%c██████████████████████████████████████%c░░░░░░░%c░%c███████%c░%c░░%c▓%c██████████%c▒%c░░░%c   %c██████████████████%c░%c███████████████████%c▓%c░░%c▒%c███████████████%c░░░%c\n%c            %c░░░░░%c▒%c░%c░%c░░░░░░░░░░░░░░░░░░░░░░%c░%c▓%c████%c▓%c░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░%c    %c░░%c░%c███████████%c▓%c░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░%c░%c▓%c█████%c▒%c░░░░%c\n%c             %c░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░%c       %c░░░░░░░░%c░%c▒%c░░░░░░░░░░░░%c░%c      %c░░░░░░░░░░░░░░░░░%c░%c░%c░░░░░░░░░░░░░░░░░░░░%c  %c░░░░░░░░░░░░░░░░%c\n%c                %c░%c░░░░%c░%c░░%c░%c                 %c░%c░░░░░░░%c                                        %c░░░░░░░░░░░░░%c       %c░%c░%c░%c                    %c░%c░%c░░░░░░░%c░%c\n\n',
    c(0, 0, 0),
    c(0, 0, 0),
    c(93, 104, 146),
    c(43, 50, 71),
    c(0, 0, 0),
    c(72, 81, 113),
    c(0, 0, 0),
    c(0, 0, 0),
    c(93, 104, 146),
    c(0, 0, 0),
    c(93, 104, 146),
    c(0, 0, 0),
    c(0, 0, 0),
    c(106, 121, 170),
    c(93, 105, 147),
    c(93, 104, 146),
    c(0, 0, 0),
    c(59, 67, 94),
    c(93, 104, 146),
    c(104, 119, 168),
    c(103, 118, 165),
    c(0, 0, 0),
    c(0, 0, 0),
    c(93, 104, 146),
    c(150, 164, 224),
    c(93, 104, 146),
    c(0, 0, 0),
    c(93, 104, 146),
    c(105, 120, 169),
    c(150, 164, 224),
    c(9, 11, 16),
    c(0, 0, 0),
    c(0, 0, 0),
    c(94, 105, 148),
    c(150, 164, 224),
    c(93, 104, 146),
    c(0, 0, 0),
    c(93, 104, 146),
    c(106, 122, 171),
    c(94, 106, 149),
    c(93, 104, 146),
    c(0, 0, 0),
    c(0, 0, 0),
    c(93, 104, 146),
    c(106, 122, 171),
    c(98, 112, 157),
    c(93, 104, 146),
    c(0, 0, 0),
    c(93, 104, 146),
    c(106, 122, 171),
    c(93, 104, 146),
    c(0, 0, 0),
    c(0, 0, 0),
    c(93, 104, 146),
    c(98, 110, 153),
    c(93, 104, 146),
    c(92, 103, 145),
    c(0, 0, 0),
    c(73, 80, 109),
    c(93, 104, 145),
    c(93, 104, 146),
    c(105, 121, 170),
    c(93, 104, 146),
    c(0, 0, 0),
    c(0, 0, 0),
    c(93, 104, 145),
    c(93, 104, 146),
    c(92, 103, 145),
    c(75, 82, 112),
    c(0, 0, 0),
    c(66, 73, 100),
    c(75, 82, 112),
    c(75, 83, 113),
    c(93, 104, 146),
    c(105, 121, 170),
    c(93, 104, 146),
    c(43, 48, 67),
    c(0, 0, 0),
    c(0, 0, 0),
    c(71, 78, 108),
    c(75, 82, 112),
    c(6, 7, 10),
    c(0, 0, 0),
    c(74, 81, 111),
    c(0, 0, 0),
    c(72, 78, 108),
    c(75, 82, 112),
    c(87, 97, 134),
    c(80, 89, 121),
    c(80, 89, 122),
    c(0, 0, 0),
    c(0, 0, 0),
    c(61, 67, 97),
    c(66, 73, 103),
    c(133, 145, 204),
    c(67, 73, 103),
    c(61, 67, 97),
    c(0, 0, 0),
    c(11, 12, 20),
    c(55, 61, 91),
    c(0, 0, 0),
    c(51, 57, 87),
    c(50, 55, 87),
    c(0, 0, 0),
    c(65, 72, 102),
    c(67, 73, 103),
    c(75, 82, 112),
    c(0, 0, 0),
    c(0, 0, 0),
    c(52, 58, 88),
    c(51, 57, 87),
    c(4, 5, 8),
    c(39, 39, 81),
    c(50, 56, 86),
    c(0, 0, 0),
    c(71, 94, 105),
    c(135, 175, 196),
    c(49, 54, 84),
    c(39, 39, 81),
    c(23, 24, 51),
    c(51, 57, 87),
    c(61, 67, 97),
    c(62, 68, 98),
    c(66, 73, 103),
    c(67, 73, 103),
    c(67, 73, 104),
    c(67, 73, 103),
    c(0, 0, 0),
    c(6, 4, 2),
    c(243, 175, 124),
    c(0, 0, 0),
    c(0, 0, 0),
    c(39, 39, 81),
    c(51, 57, 87),
    c(37, 38, 77),
    c(52, 68, 84),
    c(114, 149, 176),
    c(0, 0, 0),
    c(39, 39, 81),
    c(47, 50, 85),
    c(51, 57, 87),
    c(52, 58, 89),
    c(0, 0, 0),
    c(11, 8, 5),
    c(243, 175, 124),
    c(254, 255, 192),
    c(243, 175, 124),
    c(0, 0, 0),
    c(0, 0, 0),
    c(15, 15, 35),
    c(51, 57, 87),
    c(60, 66, 97),
    c(121, 158, 182),
    c(135, 175, 195),
    c(137, 178, 197),
    c(148, 190, 206),
    c(143, 184, 201),
    c(135, 175, 196),
    c(114, 149, 176),
    c(44, 49, 75),
    c(51, 57, 87),
    c(2, 3, 5),
    c(1, 1, 2),
    c(0, 0, 0),
    c(79, 55, 37),
    c(243, 175, 124),
    c(0, 0, 0),
    c(0, 0, 0),
    c(13, 15, 23),
    c(11, 12, 21),
    c(30, 41, 47),
    c(167, 214, 225),
    c(168, 216, 226),
    c(168, 215, 225),
    c(145, 187, 201),
    c(51, 56, 83),
    c(60, 66, 97),
    c(0, 0, 1),
    c(116, 152, 178),
    c(147, 190, 206),
    c(135, 175, 196),
    c(114, 149, 176),
    c(0, 0, 0),
    c(243, 172, 121),
    c(243, 174, 123),
    c(243, 175, 124),
    c(0, 0, 0),
    c(24, 17, 11),
    c(243, 175, 124),
    c(122, 87, 60),
    c(0, 0, 0),
    c(0, 0, 0),
    c(168, 216, 226),
    c(149, 192, 201),
    c(0, 0, 0),
    c(12, 13, 18),
    c(1, 2, 2),
    c(168, 216, 226),
    c(148, 190, 206),
    c(114, 149, 176),
    c(0, 0, 0),
    c(37, 22, 13),
    c(240, 144, 93),
    c(241, 151, 101),
    c(242, 165, 115),
    c(242, 166, 116),
    c(242, 164, 114),
    c(243, 171, 120),
    c(243, 172, 121),
    c(243, 174, 123),
    c(243, 175, 124),
    c(25, 18, 12),
    c(0, 0, 0),
    c(0, 0, 0),
    c(168, 216, 226),
    c(18, 25, 26),
    c(0, 0, 0),
    c(14, 20, 21),
    c(168, 216, 226),
    c(0, 0, 0),
    c(51, 57, 87),
    c(73, 80, 110),
    c(70, 77, 105),
    c(74, 81, 111),
    c(75, 82, 112),
    c(10, 11, 16),
    c(168, 216, 226),
    c(163, 210, 221),
    c(128, 167, 189),
    c(105, 137, 162),
    c(0, 0, 0),
    c(172, 176, 199),
    c(146, 90, 64),
    c(240, 144, 93),
    c(240, 146, 95),
    c(241, 153, 102),
    c(242, 168, 117),
    c(242, 168, 118),
    c(242, 168, 117),
    c(242, 165, 114),
    c(241, 148, 97),
    c(243, 170, 119),
    c(243, 173, 122),
    c(243, 174, 123),
    c(0, 0, 0),
    c(0, 0, 0),
    c(168, 216, 226),
    c(129, 143, 210),
    c(1, 1, 2),
    c(40, 52, 55),
    c(3, 5, 6),
    c(50, 56, 86),
    c(168, 216, 226),
    c(164, 210, 221),
    c(114, 149, 176),
    c(167, 214, 225),
    c(168, 216, 226),
    c(16, 18, 25),
    c(0, 0, 0),
    c(168, 216, 226),
    c(148, 190, 206),
    c(114, 149, 176),
    c(0, 0, 0),
    c(172, 173, 178),
    c(255, 255, 255),
    c(21, 21, 21),
    c(240, 144, 93),
    c(240, 147, 96),
    c(240, 149, 99),
    c(240, 149, 98),
    c(241, 154, 103),
    c(241, 149, 98),
    c(0, 0, 0),
    c(0, 0, 0),
    c(168, 216, 226),
    c(167, 214, 224),
    c(116, 152, 178),
    c(114, 149, 176),
    c(149, 193, 208),
    c(168, 216, 226),
    c(167, 215, 225),
    c(114, 149, 176),
    c(98, 128, 151),
    c(50, 51, 59),
    c(172, 176, 199),
    c(13, 14, 16),
    c(168, 216, 226),
    c(0, 0, 0),
    c(168, 216, 226),
    c(148, 190, 206),
    c(114, 149, 176),
    c(0, 0, 0),
    c(173, 175, 185),
    c(254, 254, 254),
    c(255, 255, 255),
    c(253, 253, 254),
    c(227, 228, 235),
    c(0, 0, 0),
    c(239, 144, 93),
    c(240, 144, 93),
    c(239, 144, 93),
    c(237, 142, 92),
    c(0, 0, 0),
    c(0, 0, 0),
    c(14, 19, 20),
    c(168, 216, 226),
    c(19, 20, 22),
    c(172, 176, 199),
    c(7, 7, 8),
    c(51, 57, 87),
    c(114, 149, 176),
    c(113, 148, 175),
    c(160, 206, 218),
    c(168, 216, 226),
    c(165, 213, 223),
    c(172, 176, 199),
    c(0, 0, 0),
    c(61, 67, 97),
    c(66, 73, 103),
    c(60, 66, 96),
    c(168, 171, 194),
    c(117, 151, 158),
    c(168, 216, 226),
    c(148, 190, 206),
    c(114, 149, 176),
    c(0, 0, 0),
    c(19, 19, 22),
    c(200, 204, 218),
    c(222, 224, 233),
    c(225, 227, 235),
    c(224, 226, 234),
    c(206, 209, 222),
    c(204, 207, 220),
    c(170, 174, 196),
    c(193, 118, 82),
    c(211, 128, 86),
    c(228, 137, 90),
    c(238, 143, 93),
    c(239, 144, 93),
    c(240, 144, 93),
    c(238, 144, 93),
    c(228, 137, 90),
    c(211, 128, 86),
    c(82, 47, 32),
    c(0, 0, 0),
    c(0, 0, 0),
    c(13, 18, 18),
    c(150, 194, 208),
    c(203, 206, 220),
    c(180, 180, 181),
    c(74, 81, 111),
    c(72, 79, 109),
    c(255, 255, 255),
    c(51, 57, 87),
    c(141, 182, 199),
    c(168, 216, 226),
    c(73, 74, 75),
    c(255, 255, 255),
    c(75, 82, 112),
    c(255, 255, 255),
    c(75, 82, 112),
    c(67, 67, 67),
    c(168, 216, 226),
    c(148, 190, 206),
    c(114, 149, 176),
    c(0, 0, 0),
    c(12, 12, 14),
    c(172, 176, 199),
    c(171, 175, 198),
    c(5, 3, 2),
    c(160, 99, 74),
    c(160, 99, 73),
    c(190, 116, 81),
    c(194, 118, 82),
    c(202, 123, 84),
    c(204, 124, 85),
    c(199, 122, 84),
    c(203, 123, 84),
    c(192, 117, 82),
    c(175, 107, 77),
    c(160, 99, 73),
    c(0, 0, 0),
    c(0, 0, 0),
    c(167, 152, 116),
    c(146, 130, 104),
    c(167, 152, 116),
    c(118, 106, 91),
    c(105, 93, 79),
    c(59, 51, 43),
    c(78, 67, 56),
    c(0, 0, 0),
    c(164, 211, 220),
    c(255, 255, 255),
    c(1, 1, 1),
    c(75, 82, 112),
    c(86, 97, 134),
    c(255, 255, 255),
    c(78, 86, 116),
    c(17, 19, 26),
    c(168, 216, 226),
    c(234, 234, 234),
    c(255, 255, 255),
    c(75, 83, 113),
    c(104, 118, 166),
    c(190, 195, 215),
    c(255, 255, 255),
    c(103, 117, 164),
    c(1, 1, 2),
    c(0, 0, 0),
    c(168, 216, 226),
    c(147, 188, 205),
    c(40, 52, 62),
    c(113, 147, 174),
    c(135, 175, 196),
    c(77, 102, 113),
    c(0, 0, 0),
    c(172, 176, 199),
    c(170, 174, 197),
    c(160, 99, 73),
    c(56, 33, 24),
    c(0, 0, 0),
    c(0, 0, 0),
    c(166, 151, 115),
    c(167, 152, 116),
    c(162, 146, 113),
    c(135, 119, 97),
    c(134, 118, 98),
    c(84, 76, 57),
    c(166, 150, 115),
    c(96, 83, 70),
    c(114, 149, 176),
    c(165, 212, 222),
    c(250, 250, 250),
    c(255, 255, 255),
    c(83, 93, 127),
    c(104, 119, 167),
    c(150, 164, 224),
    c(103, 117, 165),
    c(0, 0, 0),
    c(98, 121, 125),
    c(149, 186, 192),
    c(34, 45, 47),
    c(50, 65, 68),
    c(168, 216, 226),
    c(167, 215, 225),
    c(255, 255, 255),
    c(1, 1, 2),
    c(103, 117, 164),
    c(14, 17, 25),
    c(255, 255, 255),
    c(4, 7, 8),
    c(168, 216, 226),
    c(156, 201, 214),
    c(114, 149, 176),
    c(135, 175, 196),
    c(0, 0, 0),
    c(51, 57, 87),
    c(55, 57, 64),
    c(172, 176, 199),
    c(30, 17, 12),
    c(12, 6, 3),
    c(0, 0, 0),
    c(70, 71, 81),
    c(171, 175, 198),
    c(172, 176, 199),
    c(0, 0, 0),
    c(0, 0, 0),
    c(39, 35, 26),
    c(165, 149, 114),
    c(139, 116, 87),
    c(90, 75, 56),
    c(143, 120, 89),
    c(96, 83, 70),
    c(75, 65, 54),
    c(114, 149, 176),
    c(56, 75, 89),
    c(168, 216, 226),
    c(5, 7, 7),
    c(66, 66, 66),
    c(0, 0, 0),
    c(186, 227, 234),
    c(187, 227, 235),
    c(185, 226, 234),
    c(168, 216, 226),
    c(148, 191, 199),
    c(164, 211, 221),
    c(168, 216, 226),
    c(166, 213, 223),
    c(129, 168, 190),
    c(90, 119, 141),
    c(20, 28, 33),
    c(0, 0, 0),
    c(65, 71, 98),
    c(60, 66, 96),
    c(51, 57, 87),
    c(0, 0, 0),
    c(106, 109, 123),
    c(172, 176, 199),
    c(167, 171, 192),
    c(0, 0, 0),
    c(0, 0, 0),
    c(141, 118, 88),
    c(143, 120, 89),
    c(116, 98, 78),
    c(143, 120, 89),
    c(115, 98, 78),
    c(113, 96, 77),
    c(96, 83, 70),
    c(114, 149, 176),
    c(124, 162, 186),
    c(168, 216, 226),
    c(180, 224, 232),
    c(182, 225, 232),
    c(168, 216, 226),
    c(167, 215, 225),
    c(168, 216, 226),
    c(149, 192, 208),
    c(124, 163, 186),
    c(5, 6, 8),
    c(67, 105, 159),
    c(0, 0, 0),
    c(59, 65, 94),
    c(72, 79, 109),
    c(75, 82, 112),
    c(68, 75, 103),
    c(0, 0, 0),
    c(0, 0, 0),
    c(112, 95, 76),
    c(143, 120, 89),
    c(142, 119, 88),
    c(106, 90, 74),
    c(85, 73, 60),
    c(96, 83, 70),
    c(76, 65, 54),
    c(255, 255, 255),
    c(172, 176, 199),
    c(153, 157, 178),
    c(11, 9, 7),
    c(112, 108, 156),
    c(114, 150, 171),
    c(168, 216, 226),
    c(164, 211, 221),
    c(168, 216, 226),
    c(8, 11, 11),
    c(165, 212, 222),
    c(168, 216, 226),
    c(167, 214, 224),
    c(148, 190, 206),
    c(15, 25, 40),
    c(87, 134, 201),
    c(90, 139, 205),
    c(102, 157, 223),
    c(83, 128, 191),
    c(51, 57, 87),
    c(54, 59, 90),
    c(74, 81, 111),
    c(0, 0, 0),
    c(0, 0, 0),
    c(20, 17, 14),
    c(96, 83, 70),
    c(253, 253, 253),
    c(247, 248, 249),
    c(172, 176, 199),
    c(0, 0, 0),
    c(39, 39, 81),
    c(0, 0, 0),
    c(168, 216, 226),
    c(255, 255, 255),
    c(254, 254, 254),
    c(255, 255, 255),
    c(251, 251, 251),
    c(168, 216, 226),
    c(16, 21, 24),
    c(129, 154, 173),
    c(85, 131, 198),
    c(96, 149, 214),
    c(112, 173, 238),
    c(126, 193, 255),
    c(139, 204, 255),
    c(142, 209, 255),
    c(126, 193, 255),
    c(0, 0, 0),
    c(145, 141, 140),
    c(0, 0, 0),
    c(233, 228, 226),
    c(233, 228, 225),
    c(227, 220, 217),
    c(0, 0, 0),
    c(0, 0, 0),
    c(27, 22, 19),
    c(96, 83, 70),
    c(30, 25, 20),
    c(111, 94, 75),
    c(112, 95, 75),
    c(102, 87, 69),
    c(68, 57, 45),
    c(0, 0, 0),
    c(67, 94, 189),
    c(55, 78, 158),
    c(129, 154, 173),
    c(3, 4, 4),
    c(168, 216, 226),
    c(9, 12, 13),
    c(129, 154, 173),
    c(1, 3, 5),
    c(125, 191, 255),
    c(126, 193, 255),
    c(138, 204, 255),
    c(126, 193, 255),
    c(0, 0, 0),
    c(87, 133, 201),
    c(65, 102, 155),
    c(0, 0, 0),
    c(233, 228, 226),
    c(232, 227, 225),
    c(233, 228, 226),
    c(230, 223, 220),
    c(225, 217, 213),
    c(0, 0, 0),
    c(0, 0, 0),
    c(0, 0, 1),
    c(129, 154, 173),
    c(141, 168, 183),
    c(154, 181, 193),
    c(152, 179, 192),
    c(140, 167, 182),
    c(132, 157, 176),
    c(145, 172, 187),
    c(155, 182, 194),
    c(154, 181, 193),
    c(152, 179, 192),
    c(129, 154, 173),
    c(0, 0, 0),
    c(129, 154, 173),
    c(38, 54, 113),
    c(67, 94, 189),
    c(78, 117, 196),
    c(87, 133, 201),
    c(86, 133, 200),
    c(0, 0, 0),
    c(225, 217, 213),
    c(231, 224, 221),
    c(233, 228, 226),
    c(230, 225, 223),
    c(233, 228, 226),
    c(216, 211, 210),
    c(233, 228, 226),
    c(233, 227, 225),
    c(228, 221, 217),
    c(226, 218, 214),
    c(200, 195, 197),
    c(0, 0, 0),
    c(0, 0, 0),
    c(129, 154, 173),
    c(141, 167, 182),
    c(129, 154, 173),
    c(153, 180, 193),
    c(169, 197, 204),
    c(162, 190, 199),
    c(143, 169, 183),
    c(129, 154, 173),
    c(47, 57, 59),
    c(190, 221, 222),
    c(188, 220, 220),
    c(164, 192, 200),
    c(129, 154, 173),
    c(0, 0, 0),
    c(67, 94, 189),
    c(87, 133, 201),
    c(0, 0, 0),
    c(204, 197, 198),
    c(226, 218, 214),
    c(227, 219, 215),
    c(232, 227, 224),
    c(233, 228, 226),
    c(26, 25, 24),
    c(233, 228, 226),
    c(233, 228, 225),
    c(232, 227, 224),
    c(228, 221, 218),
    c(226, 218, 214),
    c(199, 194, 197),
    c(115, 112, 114),
    c(0, 0, 0),
    c(0, 0, 0),
    c(81, 108, 137),
    c(139, 183, 234),
    c(126, 168, 219),
    c(30, 44, 63),
    c(0, 0, 0),
    c(83, 111, 137),
    c(108, 145, 201),
    c(31, 42, 59),
    c(130, 125, 188),
    c(0, 0, 0),
    c(1, 1, 2),
    c(0, 0, 0),
    c(34, 49, 103),
    c(176, 206, 210),
    c(190, 222, 222),
    c(204, 230, 231),
    c(205, 231, 232),
    c(210, 234, 235),
    c(213, 235, 237),
    c(211, 235, 236),
    c(205, 231, 232),
    c(201, 228, 229),
    c(190, 222, 222),
    c(189, 220, 221),
    c(133, 158, 176),
    c(129, 154, 173),
    c(47, 75, 105),
    c(126, 193, 255),
    c(134, 200, 255),
    c(123, 188, 254),
    c(3, 5, 14),
    c(67, 94, 189),
    c(86, 132, 201),
    c(87, 133, 201),
    c(85, 131, 197),
    c(0, 0, 0),
    c(199, 194, 197),
    c(225, 217, 213),
    c(226, 218, 214),
    c(217, 209, 205),
    c(230, 223, 220),
    c(232, 227, 224),
    c(233, 228, 225),
    c(232, 227, 224),
    c(231, 225, 222),
    c(227, 220, 216),
    c(226, 218, 214),
    c(201, 196, 197),
    c(199, 194, 197),
    c(178, 174, 182),
    c(0, 0, 0),
    c(0, 0, 0),
    c(73, 86, 95),
    c(200, 234, 255),
    c(187, 227, 255),
    c(180, 223, 255),
    c(179, 222, 255),
    c(168, 215, 255),
    c(152, 200, 249),
    c(131, 173, 225),
    c(108, 145, 201),
    c(79, 106, 148),
    c(108, 145, 201),
    c(128, 123, 186),
    c(130, 125, 188),
    c(3, 3, 5),
    c(67, 65, 99),
    c(0, 0, 0),
    c(67, 94, 189),
    c(163, 190, 200),
    c(190, 222, 222),
    c(192, 222, 223),
    c(205, 231, 232),
    c(223, 240, 241),
    c(251, 253, 253),
    c(214, 236, 238),
    c(212, 235, 236),
    c(205, 231, 232),
    c(205, 230, 232),
    c(190, 222, 222),
    c(175, 205, 209),
    c(129, 154, 173),
    c(79, 95, 107),
    c(129, 154, 173),
    c(110, 170, 236),
    c(126, 193, 255),
    c(143, 209, 255),
    c(143, 210, 255),
    c(124, 191, 255),
    c(75, 82, 112),
    c(66, 72, 99),
    c(73, 114, 170),
    c(87, 134, 201),
    c(0, 0, 0),
    c(146, 146, 160),
    c(152, 151, 166),
    c(197, 192, 195),
    c(223, 215, 212),
    c(226, 218, 214),
    c(144, 139, 137),
    c(226, 218, 214),
    c(220, 212, 208),
    c(226, 218, 214),
    c(225, 217, 213),
    c(199, 194, 197),
    c(184, 179, 187),
    c(2, 2, 2),
    c(0, 0, 0),
    c(0, 0, 0),
    c(1, 2, 2),
    c(202, 235, 255),
    c(202, 234, 255),
    c(198, 233, 255),
    c(191, 229, 255),
    c(180, 223, 255),
    c(179, 222, 255),
    c(159, 210, 255),
    c(114, 152, 207),
    c(108, 145, 201),
    c(1, 1, 1),
    c(255, 255, 255),
    c(225, 226, 234),
    c(172, 176, 199),
    c(130, 125, 188),
    c(0, 0, 0),
    c(150, 177, 190),
    c(190, 222, 222),
    c(9, 11, 11),
    c(186, 211, 212),
    c(199, 225, 226),
    c(208, 231, 233),
    c(206, 229, 231),
    c(195, 219, 221),
    c(158, 178, 179),
    c(190, 222, 222),
    c(171, 200, 206),
    c(129, 154, 173),
    c(15, 26, 41),
    c(87, 134, 201),
    c(12, 19, 37),
    c(43, 47, 83),
    c(51, 57, 87),
    c(67, 74, 104),
    c(75, 82, 112),
    c(3, 3, 5),
    c(255, 255, 255),
    c(179, 182, 203),
    c(109, 112, 126),
    c(150, 149, 163),
    c(152, 151, 166),
    c(114, 111, 113),
    c(207, 201, 201),
    c(226, 218, 214),
    c(225, 217, 213),
    c(201, 195, 197),
    c(199, 194, 197),
    c(196, 190, 195),
    c(182, 178, 186),
    c(0, 0, 0),
    c(0, 0, 0),
    c(178, 211, 233),
    c(180, 223, 255),
    c(178, 222, 255),
    c(159, 210, 255),
    c(158, 208, 254),
    c(108, 145, 201),
    c(83, 112, 156),
    c(108, 145, 201),
    c(110, 110, 111),
    c(255, 255, 255),
    c(223, 224, 233),
    c(172, 176, 199),
    c(172, 176, 198),
    c(130, 125, 188),
    c(0, 0, 0),
    c(67, 94, 189),
    c(54, 63, 90),
    c(190, 222, 222),
    c(191, 222, 222),
    c(205, 231, 232),
    c(207, 232, 233),
    c(248, 252, 252),
    c(255, 255, 255),
    c(214, 236, 238),
    c(205, 231, 232),
    c(192, 222, 223),
    c(190, 222, 222),
    c(189, 221, 221),
    c(167, 195, 203),
    c(129, 154, 173),
    c(20, 24, 32),
    c(67, 94, 189),
    c(67, 94, 188),
    c(50, 56, 86),
    c(172, 176, 199),
    c(0, 0, 1),
    c(213, 215, 226),
    c(255, 255, 255),
    c(249, 249, 249),
    c(31, 31, 34),
    c(88, 87, 97),
    c(152, 151, 166),
    c(166, 163, 175),
    c(172, 169, 179),
    c(177, 174, 183),
    c(172, 169, 179),
    c(0, 0, 0),
    c(0, 0, 0),
    c(108, 145, 201),
    c(0, 0, 0),
    c(130, 125, 188),
    c(0, 0, 0),
    c(67, 94, 189),
    c(7, 12, 27),
    c(189, 221, 221),
    c(203, 230, 231),
    c(205, 230, 232),
    c(204, 230, 231),
    c(205, 231, 232),
    c(253, 254, 254),
    c(205, 231, 232),
    c(205, 230, 232),
    c(190, 222, 222),
    c(136, 161, 178),
    c(109, 130, 146),
    c(129, 154, 173),
    c(64, 91, 181),
    c(67, 94, 189),
    c(172, 176, 199),
    c(250, 251, 251),
    c(255, 255, 255),
    c(65, 64, 71),
    c(152, 151, 166),
    c(140, 139, 153),
    c(5, 5, 6),
    c(0, 0, 0),
    c(0, 0, 0),
    c(255, 255, 255),
    c(0, 0, 0),
    c(255, 255, 255),
    c(0, 0, 0),
    c(255, 255, 255),
    c(0, 0, 0),
    c(115, 153, 188),
    c(159, 209, 255),
    c(117, 156, 210),
    c(108, 145, 201),
    c(96, 128, 178),
    c(255, 255, 255),
    c(211, 232, 232),
    c(190, 222, 222),
    c(204, 230, 231),
    c(215, 236, 238),
    c(208, 232, 233),
    c(205, 231, 232),
    c(204, 230, 231),
    c(191, 222, 222),
    c(190, 222, 222),
    c(0, 0, 0),
    c(128, 142, 206),
    c(255, 255, 255),
    c(163, 172, 217),
    c(67, 94, 189),
    c(0, 0, 2),
    c(172, 176, 199),
    c(180, 183, 203),
    c(175, 179, 201),
    c(173, 177, 199),
    c(160, 164, 185),
    c(172, 176, 199),
    c(255, 255, 255),
    c(0, 0, 0),
    c(255, 255, 255),
    c(0, 0, 0),
    c(0, 0, 0),
    c(255, 255, 255),
    c(0, 0, 0),
    c(255, 255, 255),
    c(0, 0, 0),
    c(129, 171, 209),
    c(159, 210, 255),
    c(0, 0, 0),
    c(255, 255, 255),
    c(168, 172, 194),
    c(152, 151, 166),
    c(131, 134, 151),
    c(172, 176, 199),
    c(40, 41, 47),
    c(255, 255, 255),
    c(0, 0, 0),
    c(255, 255, 255),
    c(0, 0, 0),
    c(0, 0, 0),
    c(255, 255, 255),
    c(0, 0, 0),
    c(255, 255, 255),
    c(0, 0, 0),
    c(255, 255, 255),
    c(254, 254, 254),
    c(226, 218, 214),
    c(207, 207, 207),
    c(255, 255, 255),
    c(0, 0, 0),
    c(0, 0, 0),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(60, 196, 253),
    c(255, 255, 255),
    c(248, 253, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(0, 0, 0),
    c(255, 255, 255),
    c(42, 191, 253),
    c(66, 198, 253),
    c(210, 241, 254),
    c(255, 255, 255),
    c(254, 254, 255),
    c(42, 191, 253),
    c(247, 252, 255),
    c(255, 255, 255),
    c(226, 218, 214),
    c(255, 255, 255),
    c(42, 191, 253),
    c(43, 191, 253),
    c(255, 255, 255),
    c(160, 226, 253),
    c(42, 191, 253),
    c(51, 193, 253),
    c(171, 229, 254),
    c(252, 254, 255),
    c(255, 255, 255),
    c(0, 0, 0),
    c(255, 255, 255),
    c(130, 217, 253),
    c(42, 191, 253),
    c(255, 255, 255),
    c(253, 254, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(0, 0, 0),
    c(255, 255, 255),
    c(42, 191, 253),
    c(247, 252, 254),
    c(42, 191, 253),
    c(0, 1, 2),
    c(89, 205, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(0, 0, 0),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(254, 254, 255),
    c(255, 255, 255),
    c(0, 0, 0),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(251, 253, 255),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(72, 92, 144),
    c(0, 0, 0),
    c(255, 255, 255),
    c(42, 191, 253),
    c(43, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(179, 232, 254),
    c(255, 255, 255),
    c(65, 198, 253),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(219, 244, 254),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(72, 92, 144),
    c(0, 0, 0),
    c(73, 93, 145),
    c(255, 255, 255),
    c(42, 191, 253),
    c(204, 239, 254),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(191, 236, 254),
    c(255, 255, 255),
    c(175, 231, 254),
    c(46, 192, 253),
    c(42, 191, 253),
    c(210, 241, 254),
    c(255, 255, 255),
    c(42, 191, 253),
    c(243, 251, 255),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(142, 221, 254),
    c(42, 191, 253),
    c(103, 209, 253),
    c(255, 255, 255),
    c(80, 99, 149),
    c(72, 92, 144),
    c(0, 0, 0),
    c(71, 91, 143),
    c(165, 175, 200),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(62, 197, 253),
    c(187, 235, 254),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(176, 231, 254),
    c(255, 255, 255),
    c(197, 237, 254),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(72, 92, 144),
    c(79, 95, 143),
    c(0, 0, 0),
    c(72, 92, 144),
    c(251, 252, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(136, 219, 254),
    c(255, 255, 255),
    c(54, 195, 253),
    c(42, 191, 253),
    c(255, 255, 255),
    c(163, 227, 253),
    c(42, 191, 253),
    c(77, 202, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(45, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(72, 92, 144),
    c(0, 0, 0),
    c(0, 0, 0),
    c(72, 92, 144),
    c(255, 255, 255),
    c(206, 240, 254),
    c(42, 191, 253),
    c(255, 255, 255),
    c(151, 223, 254),
    c(42, 191, 253),
    c(42, 140, 253),
    c(42, 109, 253),
    c(255, 255, 255),
    c(42, 109, 253),
    c(41, 108, 252),
    c(40, 108, 250),
    c(255, 255, 255),
    c(132, 168, 236),
    c(24, 120, 229),
    c(40, 185, 251),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(254, 254, 255),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 182, 253),
    c(42, 111, 253),
    c(42, 109, 253),
    c(255, 255, 255),
    c(72, 92, 144),
    c(0, 0, 0),
    c(0, 0, 0),
    c(72, 92, 144),
    c(255, 255, 255),
    c(49, 193, 253),
    c(42, 191, 253),
    c(42, 171, 253),
    c(42, 109, 253),
    c(255, 255, 255),
    c(42, 109, 253),
    c(255, 255, 255),
    c(238, 243, 254),
    c(42, 109, 253),
    c(229, 237, 254),
    c(255, 255, 255),
    c(42, 109, 253),
    c(42, 115, 253),
    c(42, 160, 253),
    c(42, 191, 253),
    c(255, 255, 255),
    c(42, 191, 253),
    c(247, 252, 255),
    c(255, 255, 255),
    c(42, 191, 253),
    c(42, 143, 253),
    c(42, 109, 253),
    c(255, 255, 255),
    c(42, 109, 253),
    c(135, 172, 253),
    c(255, 255, 255),
    c(75, 94, 145),
    c(72, 92, 144),
    c(0, 0, 0),
    c(0, 0, 0),
    c(72, 92, 144),
    c(255, 255, 255),
    c(42, 109, 253),
    c(158, 189, 253),
    c(42, 109, 253),
    c(255, 255, 255),
    c(254, 254, 255),
    c(42, 109, 253),
    c(48, 113, 253),
    c(255, 255, 255),
    c(235, 241, 254),
    c(42, 109, 253),
    c(255, 255, 255),
    c(184, 206, 254),
    c(42, 109, 253),
    c(255, 255, 255),
    c(42, 109, 253),
    c(50, 114, 253),
    c(255, 255, 255),
    c(42, 109, 253),
    c(255, 255, 255),
    c(42, 109, 253),
    c(255, 255, 255),
    c(72, 92, 144),
    c(72, 72, 145),
    c(0, 0, 0),
    c(0, 0, 0),
    c(72, 92, 144),
    c(255, 255, 255),
    c(42, 109, 253),
    c(226, 235, 254),
    c(42, 109, 253),
    c(253, 254, 255),
    c(42, 109, 253),
    c(255, 255, 255),
    c(42, 109, 253),
    c(255, 255, 255),
    c(42, 109, 253),
    c(52, 116, 253),
    c(255, 255, 255),
    c(116, 159, 253),
    c(42, 109, 253),
    c(255, 255, 255),
    c(214, 227, 255),
    c(193, 212, 254),
    c(227, 236, 255),
    c(42, 109, 253),
    c(255, 255, 255),
    c(42, 109, 253),
    c(255, 255, 255),
    c(252, 253, 255),
    c(42, 109, 253),
    c(255, 255, 255),
    c(72, 92, 144),
    c(0, 0, 0),
    c(0, 0, 0),
    c(72, 91, 145),
    c(72, 92, 144),
    c(255, 255, 255),
    c(42, 109, 253),
    c(255, 255, 255),
    c(42, 109, 253),
    c(255, 255, 255),
    c(42, 109, 253),
    c(255, 255, 255),
    c(42, 109, 253),
    c(255, 255, 255),
    c(42, 109, 253),
    c(255, 255, 255),
    c(226, 235, 254),
    c(42, 109, 253),
    c(255, 255, 255),
    c(209, 223, 254),
    c(42, 109, 253),
    c(46, 112, 253),
    c(42, 109, 253),
    c(255, 255, 255),
    c(207, 222, 254),
    c(42, 109, 253),
    c(255, 255, 255),
    c(245, 246, 249),
    c(72, 92, 144),
    c(0, 0, 0),
    c(0, 0, 0),
    c(71, 91, 144),
    c(95, 112, 158),
    c(255, 255, 255),
    c(42, 109, 253),
    c(255, 255, 255),
    c(42, 109, 253),
    c(255, 255, 255),
    c(42, 109, 253),
    c(255, 255, 255),
    c(42, 109, 253),
    c(146, 180, 254),
    c(42, 109, 253),
    c(255, 255, 255),
    c(253, 254, 255),
    c(42, 109, 253),
    c(255, 255, 255),
    c(42, 109, 253),
    c(255, 255, 255),
    c(61, 121, 253),
    c(42, 109, 253),
    c(214, 227, 254),
    c(255, 255, 255),
    c(72, 92, 144),
    c(71, 91, 143),
    c(0, 0, 0),
    c(0, 0, 0),
    c(72, 92, 144),
    c(212, 217, 229),
    c(255, 255, 255),
    c(42, 109, 253),
    c(174, 199, 254),
    c(255, 255, 255),
    c(42, 109, 253),
    c(255, 255, 255),
    c(51, 115, 253),
    c(42, 109, 253),
    c(177, 202, 254),
    c(255, 255, 255),
    c(42, 109, 253),
    c(181, 204, 254),
    c(255, 255, 255),
    c(251, 252, 255),
    c(42, 109, 253),
    c(255, 255, 255),
    c(253, 253, 254),
    c(72, 92, 144),
    c(255, 255, 255),
    c(42, 109, 253),
    c(255, 255, 255),
    c(252, 252, 255),
    c(42, 109, 253),
    c(240, 244, 254),
    c(255, 255, 255),
    c(42, 109, 253),
    c(255, 255, 255),
    c(43, 110, 253),
    c(42, 109, 253),
    c(255, 255, 255),
    c(72, 92, 144),
    c(0, 0, 255),
    c(0, 0, 0),
    c(0, 0, 0),
    c(72, 92, 144),
    c(255, 255, 255),
    c(42, 109, 253),
    c(62, 122, 253),
    c(108, 154, 253),
    c(211, 225, 255),
    c(255, 255, 255),
    c(195, 214, 254),
    c(42, 109, 253),
    c(255, 255, 255),
    c(72, 92, 144),
    c(255, 255, 255),
    c(42, 109, 253),
    c(255, 255, 255),
    c(251, 252, 255),
    c(255, 255, 255),
    c(94, 144, 253),
    c(42, 109, 253),
    c(255, 255, 255),
    c(72, 92, 144),
    c(0, 0, 0),
    c(0, 0, 0),
    c(72, 92, 144),
    c(255, 255, 255),
    c(221, 225, 234),
    c(74, 94, 145),
    c(255, 255, 255),
    c(90, 108, 155),
    c(72, 92, 144),
    c(0, 0, 127),
    c(0, 0, 0),
    c(255, 255, 255),
    c(72, 92, 144),
    c(0, 0, 0),
    c(0, 0, 0),
    c(72, 92, 144),
    c(79, 98, 148),
    c(255, 255, 255),
    c(72, 92, 144),
    c(74, 94, 145),
    c(255, 255, 255),
    c(90, 107, 155),
    c(72, 92, 144),
    c(225, 228, 236),
    c(255, 255, 255),
    c(150, 161, 191),
    c(72, 92, 144),
    c(0, 0, 0),
    c(255, 255, 255),
    c(72, 92, 144),
    c(255, 255, 255),
    c(194, 201, 218),
    c(72, 92, 144),
    c(150, 162, 192),
    c(255, 255, 255),
    c(72, 92, 144),
    c(0, 0, 0),
    c(0, 0, 0),
    c(72, 92, 144),
    c(121, 136, 174),
    c(106, 122, 164),
    c(81, 101, 150),
    c(72, 92, 144),
    c(74, 94, 145),
    c(238, 240, 244),
    c(255, 255, 255),
    c(184, 192, 212),
    c(72, 92, 144),
    c(0, 0, 0),
    c(72, 92, 144),
    c(81, 100, 149),
    c(255, 255, 255),
    c(213, 217, 229),
    c(72, 92, 144),
    c(78, 98, 148),
    c(201, 207, 222),
    c(255, 255, 255),
    c(134, 147, 181),
    c(72, 92, 144),
    c(0, 0, 0),
    c(0, 0, 0),
    c(72, 92, 144),
    c(0, 0, 0),
    c(72, 92, 144),
    c(72, 92, 143),
    c(127, 127, 255),
    c(72, 92, 144),
    c(71, 91, 143),
    c(0, 0, 0),
    c(72, 92, 144),
    c(71, 91, 143),
    c(68, 88, 147),
    c(72, 92, 144),
    c(0, 0, 0),
    c(72, 92, 144),
    c(0, 0, 0),
    c(0, 0, 0),
    c(70, 92, 143),
    c(72, 92, 144),
    c(71, 92, 143),
    c(72, 92, 144),
    c(75, 90, 150),
    c(0, 0, 0),
    c(72, 91, 143),
    c(72, 92, 144),
    c(0, 0, 0),
    c(72, 92, 144),
    c(0, 0, 0),
    c(70, 99, 141),
    c(73, 92, 143),
    c(72, 91, 145),
    c(0, 0, 0),
    c(69, 92, 139),
    c(71, 92, 143),
    c(72, 92, 144),
    c(71, 92, 144),
    c(0, 0, 0)
  )

  let lang: string = ((navigator as any).language as string) || ((navigator as any).userLanguage as string) || 'en'
  if (lang.includes('-')) {
    lang = lang.split('-')[1]
  }

  let { title, subtitle, warn, info } = TRANSLATIONS[lang.toLowerCase()] || TRANSLATIONS['en']

  console.log(
    '%c' + title,
    'color:#7289da;font-family:system-ui;font-size:4rem;-webkit-text-stroke: 1px black;font-weight:bold'
  )

  console.log('%c' + subtitle, 'color:#7289da;font-family:arial;font-size:16px;padding-top: 10px;font-weight:bold;')

  console.log('%c' + warn, 'color:#FF0000;font-family:arial;font-size:18px;font-weight:bold;padding-top: 10px;')

  console.log('%c' + info, 'color:#7289da;font-family:arial;font-size:16px;padding-top: 10px;')
}
